import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { sawinFunc, ResetStore, APIContainer, LogTypes } from './sawinLib';
import * as ServiceContractRnwMdls from '../models/ServiceContractRenewViewModel';
import * as ChargeRenewMdls from '../models/ServiceContractRenewChargeViewModel';
import * as CreditCardMdl from '../models/CreditCardModel';
import { RenewContractSetInitialValues } from './ServiceContractRenewCharge';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.


export interface ServiceContractRenewLoad { type: 'SERVICECONTRACTRENEW_LOAD', newState: ServiceContractRnwMdls.ServiceContractRenewViewModel }
export interface ServiceContractRenewLoading { type: 'SERVICECONTRACTRENEW_LOADING' }
export interface ServiceContractRenewProcessing { type: 'SERVICECONTRACTRENEW_PROCESSING' }
export interface ServiceContractRenewSuccess { type: 'SERVICECONTRACTRENEW_SUCCESS' }
export interface ServiceContractRenewError { type: 'SERVICECONTRACTRENEW_ERROR', error: string }
export interface ServiceContractRenewReset { type: 'SERVICECONTRACTRENEW_RESET' }

export type KnownAction = ServiceContractRenewLoad | ServiceContractRenewLoading | ResetStore | RenewContractSetInitialValues | ServiceContractRenewProcessing | ServiceContractRenewError | ServiceContractRenewSuccess | ServiceContractRenewReset;

export const actionCreators = {
    loadServiceContractRenewInfo: (pOldContractNumber: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();

        var ServiceMasterNumber = appState.sessionState.SelectedSM.id;
        var CompanyCode = appState.sessionState.SelectedAR.companyCode;

        dispatch({ type: 'SERVICECONTRACTRENEW_LOADING' });
        var fetchURL = `api/Proxy/ServiceContractRenewalInfo?CompanyCode=${CompanyCode}&ServiceMasterNum=${ServiceMasterNumber}&OldContractNumber=${pOldContractNumber}`;
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + fetchURL,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                if (container.success) {
                    const data: ServiceContractRnwMdls.ServiceContractRenewViewModel = container.data;
                    dispatch({ type: 'SERVICECONTRACTRENEW_LOAD', newState: data });                
            } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
            }
            });

    },
    setInfoForChargeScreen: (contractNumber: string, amount: number): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: 'RENEWCONTRACT_INITIALVALUES', contractNumber: contractNumber, amount: amount });
    },
    rewewWithNoCharge: (contractToPayInfo: ServiceContractRnwMdls.ServiceContractRenewViewModel): AppThunkAction<KnownAction> => (dispatch, getState) => {

        const appState = getState();
        const sessionState = appState.sessionState;        

        var ChargeInvoiceMdl: ChargeRenewMdls.ServiceContractRenewChargeViewModel = ChargeRenewMdls.ServiceContractRenewViewModelInitialState;

        ChargeInvoiceMdl = {
            ...ChargeInvoiceMdl, ...{
                creditCardInfo: CreditCardMdl.initialState,
                companyCode: sessionState.SelectedAR.companyCode,
                entityCode: 'Customer',
                entityType: 'C',
                amountToCharge: contractToPayInfo.newContract.contractAmount,
                arNum: sessionState.SelectedAR.id,
                oldContractNum: contractToPayInfo.oldContract.id,
                serviceMasterNum: sessionState.SelectedSM.id
            }
        };
     
        dispatch({ type: 'SERVICECONTRACTRENEW_PROCESSING' });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/ServiceContractRenewNoCharge',
            {
                method: 'POST',
                body: JSON.stringify(ChargeInvoiceMdl),
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                try {
                    const result = container.data;
                    if (result) {
                        dispatch({ type: 'SERVICECONTRACTRENEW_ERROR', error: result });
                    }
                    dispatch({ type: 'SERVICECONTRACTRENEW_SUCCESS' });

                } catch {
                    console.log(`Catch ${container.errorInfo.message}`);
                    dispatch({
                        type: 'SERVICECONTRACTRENEW_ERROR', error: container.errorInfo.message
                    })
                }
            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'SERVICECONTRACTRENEW_ERROR', error: err.message
                })
            });

    },
    resetState: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: "SERVICECONTRACTRENEW_RESET" });
    }
};

export const reducer: Reducer<ServiceContractRnwMdls.ServiceContractRenewViewModel> = (state: ServiceContractRnwMdls.ServiceContractRenewViewModel | undefined, incomingAction: Action): ServiceContractRnwMdls.ServiceContractRenewViewModel => {

    if (state === undefined) {
        return { ...ServiceContractRnwMdls.ServiceContractRenewViewModelInitialState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'SERVICECONTRACTRENEW_LOADING':
            return { ...state, loading: true }
        case 'SERVICECONTRACTRENEW_LOAD':
            const actionPayload = incomingAction as ServiceContractRenewLoad;
            return { ...state, ...actionPayload.newState, loading: false, processing:false }
        case 'SERVICECONTRACTRENEW_PROCESSING':
            return { ...state, processing: true }            
        case 'SERVICECONTRACTRENEW_SUCCESS':
            return { ...state, result: "RENEW" }            
        case 'SERVICECONTRACTRENEW_ERROR':
            const errorPayload = incomingAction as ServiceContractRenewError;
            return { ...state, result: errorPayload.error }            
        case 'STORE_RESET':
        case 'SERVICECONTRACTRENEW_RESET':
            return { ...ServiceContractRnwMdls.ServiceContractRenewViewModelInitialState };                    
        default:
            return state;
    }
}; 